import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ratingRouding'
})
export class RatingRoudingPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    const floor = Math.floor(value);
    if (floor <= value && value <= floor + 0.25 ){
      return `${floor}`;
    } else {
      if (floor + 0.25 <= value && value <= floor + 0.75) {
        return `${floor + 0.5}`;
      }
      return `${floor + 1}`;
    }
  }

}
